import {
  Heading,
  HStack,
  Spacer,
  Stack,
  useDisclosure,
} from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import { GhostButton, PrimaryButton } from 'components/buttons';
import { Card, CardContent } from 'components/cards/Card';
import { CardHighlightIcon } from 'components/cards/CardHighlightIcon';
import { CloneIcon } from 'components/icons';
import React from 'react';
import { PageTemplatePreviewModal } from './PageTemplatePreviewModal';
export interface PageTemplateCardProps {
  templateName: string;
  templateContent: string;
  onUseTemplate: (content: string) => void;
}

export const PageTemplateCard = ({
  templateName,
  templateContent,
  onUseTemplate,
}: PageTemplateCardProps) => {
  const {
    isOpen: isPreviewOpen,
    onOpen: onOpenPreview,
    onClose: onClosePreview,
  } = useDisclosure();

  return (
    <>
      <Card w="100%">
        <Stack direction="row" spacing={0}>
          <CardHighlightIcon>
            <CloneIcon />
          </CardHighlightIcon>
          <CardContent>
            <Stack spacing={8}>
              <Heading size="sm" fontWeight="normal">
                {templateName}
              </Heading>
              <HStack spacing="2" align="end">
                <Spacer />
                <GhostButton
                  size="sm"
                  fontWeight="bold"
                  onClick={onOpenPreview}
                >{t`Preview`}</GhostButton>
                <PrimaryButton
                  size="sm"
                  onClick={() => onUseTemplate(templateContent)}
                  fontWeight="bold"
                >{t`Use`}</PrimaryButton>
              </HStack>
            </Stack>
          </CardContent>
        </Stack>
      </Card>
      <PageTemplatePreviewModal
        templateName={templateName}
        templateContent={templateContent}
        onUseTemplate={onUseTemplate}
        onClose={onClosePreview}
        isOpen={isPreviewOpen}
      />
    </>
  );
};
